
import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FieldActivityLogModel } from '@core/models/models';
import { getHeaderItems } from '@core/helper';
import { TimeService } from '@core/services/common/time.service';
import { Subscription } from 'rxjs';
import { ActivityLogType } from '@core/configs';
import { FieldActivityLogController } from '../field-activity-log-contoller';


@Component({
  selector: 'caremoni-field-activity-header',
  templateUrl: './field-activity-header.component.html',
  styleUrl: './field-activity-header.component.scss'
})
export class FieldActivityHeaderComponent implements OnInit,AfterViewInit, OnDestroy{
  @ViewChild('parent', { static: true }) parentRef!: ElementRef;
  @ViewChild('child', { static: true }) childRef!: ElementRef;
  @Input() data: any[] = [];
  @Input() config: FieldActivityLogModel = new FieldActivityLogModel();
  headers:any[] = [];
  timeItems:any =[]
  width = '100%';

  positionHeader = 0;
  isViewInitialized = false;

  positionGridSub!: Subscription;
  timeSub!: Subscription;
  changeHeaderSizedSub!: Subscription;

  constructor(
    private timeService: TimeService,   
    private controller: FieldActivityLogController) {}
  


  ngOnDestroy(): void {
    if (this.positionGridSub) this.positionGridSub.unsubscribe();
    if(this.timeSub) this.timeSub.unsubscribe();
    if(this.changeHeaderSizedSub) this.changeHeaderSizedSub.unsubscribe();
    
  }
  
  ngAfterViewInit(): void {
    this.handerFirstAndLastHeader();
  }
  ngOnInit(): void {
    this.isViewInitialized = false;
    this.headers = getHeaderItems(this.config, this.timeService.getCurrentTime());
    this.width = `${this.headers.length * 100 / this.config.segmentNum}%`

    this.controller.setConfig(this.config);
    this.controller.setParantHeander(this.parentRef);
    
    let endhours = this.controller.getEndTime(this.timeService.getCurrentTime(), this.config)
    let potionGrid = this.controller.getPostionGrid(this.timeService.getCurrentTime(), this.config, endhours);
    this.positionHeader = this.getPositionHeader(potionGrid, this.config);
   
    this.positionGridSub = this.controller.getChangePositionGrid().subscribe(this.onPostionGridChange.bind(this))
    this.timeSub =this.controller.getChangeTime().subscribe(this.onTimeChange.bind(this));

    this.changeHeaderSizedSub = this.controller.getChangeSizeHeader().subscribe((width: any) => {
      this.handerFirstAndLastHeader();
    })
  }

  onPostionGridChange(postion: any) {
    if(postion) {
      this.positionHeader = this.getPositionHeader(postion, this.config);
      this.handerFirstAndLastHeader();
    }
  }

  onTimeChange(time: any) {
    this.headers = getHeaderItems(this.config, this.timeService.getCurrentTime());
  }

  getPositionHeader(postionGrid:any, config: any): any {
    if (postionGrid ) {
      if(this.config.type == ActivityLogType.LogCurrent)
        return postionGrid - (100 / this.config.segmentNum) / 2;
      else 
        return postionGrid ;
    }
    return 0;
  }

  handerFirstAndLastHeader(){
    if(this.parentRef && this.childRef && this.config.type == ActivityLogType.LogCurrent) {
      const child = this.childRef.nativeElement;
      const parent = this.parentRef?.nativeElement;
      const parentRect = parent.getBoundingClientRect();
      if(child.children.length >0) {
        for (let i = 0; i < child.children.length; i++) {
          if (child.children[i] && child.children[i]?.children[0] && child.children[i]) {
            const el = child.children[i]?.children[0];
            const chideRect = el.getBoundingClientRect();

            let width =  chideRect.width;
            let offsetRight = parentRect.right - chideRect.right;
            let offsetLeft = parentRect.left - chideRect.left;

            if(offsetRight < 0) {
              if (offsetRight >= (-width/2 - 1)) {
                el.children[0].style.left = `${offsetRight}px`;
              } else {
                el.children[0].style.left = `${-offsetRight}px`;
              }
            } else if (offsetLeft > 0) {
              if(offsetLeft <= (width/2 )) {
                el.children[0].style.left = `${offsetLeft}px`;
              } else {
                el.children[0].style.left = `${-2*offsetLeft}px`;
              }
            }
            else {
              el.children[0].style.left = `0px`;
            }
          }
        }
      }
    }
  }
}
